import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { JsonApiModule } from 'angular2-jsonapi'
import { CookieService } from 'ngx-cookie-service'

import { PkwDatastore } from './pkw-datastore'
import { PkwDatastoreIdentificacao } from './pkw-datastore-identificacao'

@NgModule({
    imports: [BrowserModule, JsonApiModule],
    providers: [CookieService, PkwDatastore, PkwDatastoreIdentificacao],
    declarations: [],
})
export class PkwDataModule {}



// WEBPACK FOOTER //
// ./src/app/pkw-data/pkw-data.module.ts